import { ReactNode, useState } from "react";

interface ButtonProps {
  icon?: string;
  iconRight?: string;
  onClick?: () => void;
  variant?: string;
  className?: string;
  children?: ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  icon,
  iconRight,
  children,
  onClick,
  variant = "outlined",
  className,
}) => {
  const [shouldRotateArrow, setShouldRotateArrow] = useState(false);

  return (
    <button
      onClick={() => {
        if (onClick) {
          onClick();
        }

        if (iconRight) {
          setShouldRotateArrow((prevState) => !prevState);
        }
      }}
      className={`custom_button ${variant} ${className}`}
    >
      {icon && <img src={icon} alt={icon} />}
      {children ? <span className="button_value">{children}</span> : ""}
      {iconRight && (
        <img
          className={`arrow_icon ${!shouldRotateArrow ? "rotated" : ""}`}
          src={iconRight}
          alt="iconRight"
        ></img>
      )}
    </button>
  );
};
export default Button;
